import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app.routes';
import { PopoverComponent } from '@components/popover/popover.component';
import { UserMenuComponent } from '@components/user-menu/user-menu.component';
import { ContactButtonComponent } from '@components/contact-button/contact-button.component';
import { LoginButtonComponent } from '@components/login-button/login-button.component';
import { FooterComponent } from '@components/footer/footer.component';
import { HeaderComponent } from '@components/header/header.component';
import { AlertMessageComponent } from '@components/alert-message/alert-message.component';
import { AlertModalComponent } from '@components/alert-modal/alert-modal.component';
import { AlertInlineComponent } from '@components/alert-inline/alert-inline.component';
import { AppContainer } from './containers/app.container';
import { AppConfigService } from '@services/app-config.service';
import { SafePipe } from './pipes/safe.pipe';
import { AuthIntercepterInterceptor } from './interceptors/auth-intercepter.interceptor';
import { registerLocaleData } from '@angular/common';
import localeNlBE from '@angular/common/locales/nl-BE';
import { ServiceWorkerModule } from '@angular/service-worker';

registerLocaleData(localeNlBE);

export function initializeApp(appConfigService: AppConfigService) {
    return () => appConfigService.load();
}

@NgModule({
    declarations: [
        PopoverComponent,
        UserMenuComponent,
        ContactButtonComponent,
        LoginButtonComponent,
        FooterComponent,
        HeaderComponent,
        AlertModalComponent,
        AlertMessageComponent,
        AlertInlineComponent,
        AlertModalComponent,
        AppContainer,
        SafePipe
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: true,
            registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    providers: [
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppConfigService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthIntercepterInterceptor,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'nl-BE'
        }
    ],
    bootstrap: [AppContainer]
})

export class AppModule { }
